import { FC, useMemo } from "react";
import SourceDataItemValue, { ISourceDataItemValueProps } from "./SourceDataItemValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppSettings } from "@/AppSettings";
import { Box, styled, tooltipClasses } from "@mui/material";
import { StatusListNoteTable, StatusListNoteTooltip } from "@/components/lists/status/StatusListStats";

const Tooltip = styled(StatusListNoteTooltip)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        minWidth: 300,
    }
}))

const TooltipTable = styled(StatusListNoteTable)(({ theme }) => ({
    '& td': {
        padding: theme.spacing(1),
        textAlign: 'left',
        whiteSpace: 'nowrap',
        '&:first-of-type': {
            width: 80
        }
    }
}))

const SourceDataItemMultipleCheckboxValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {


    const value = useMemo(() => {
        const values = itemData?.sourceDataItem?.value?.split(',').map(x => x?.trim());

        return itemData?.itemValueConfigurations?.map((itemValueConfiguration) => {
            const isSelected = values?.includes(itemValueConfiguration.itemValue);

            const valueDisplayName = itemValueConfiguration?.displayName;

            return (
                <SourceDataItemValue
                    key={itemValueConfiguration.itemValue}
                    hideBorderStyles={hideBorderStyles}
                    hideStyles={hideStyles}
                    startAdornment={
                        <FontAwesomeIcon 
                            size="lg"
                            icon={isSelected ? AppSettings.icons.itemValueCheckboxChecked : AppSettings.icons.itemValueCheckboxUnchecked} 
                        />
                    }
                >
                    {valueDisplayName}
                </SourceDataItemValue>
            );
        }, undefined)
    }, [itemData?.sourceDataItem?.value, itemData?.itemValueConfigurations])

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}
        >
            {value}
        </Box>
    );
};

const SourceDataItemSingleCheckboxValue: FC<ISourceDataItemValueProps> = ({
    itemData,
    hideBorderStyles,
    hideStyles
}) => {
    const isYes = itemData?.sourceDataItem?.value === '1';

    return (
        <SourceDataItemValue
            hideBorderStyles={hideBorderStyles}
            hideStyles={hideStyles}
            startAdornment={
                <FontAwesomeIcon 
                    size="lg"
                    icon={isYes ? AppSettings.icons.itemValueCheckboxChecked : AppSettings.icons.itemValueCheckboxUnchecked} 
                />
            }
        >
            {itemData?.value}
        </SourceDataItemValue>
    );
};

const SourceDataItemCheckboxValue: FC<ISourceDataItemValueProps> = (props) => {
    const itemData = props.itemData;

    const isSingle = useMemo(() => {
        return (itemData?.itemValueConfigurations?.length ?? 0) <= 1;
    }, [itemData?.itemValueConfigurations])

    if (isSingle) {
        return (
            <SourceDataItemSingleCheckboxValue {...props} />
        )
    }

    return (
        <SourceDataItemMultipleCheckboxValue {...props} />
    );
};

export default SourceDataItemCheckboxValue;